module.exports = __webpack_public_path__ + "img/icons8_netflix_1.bb0d6180.svg";